/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */
/**
 * @module event-emitter
 */
import { EventEmitter } from "./event-emitter.js";
export const eventEmitter = new EventEmitter();
